const ApiConstants = {
    API_USER_FAIL: "API_USER_FAIL",
    API_USER_ERROR: "API_USER_ERROR",
    API_GET_LIST_LOAD: "API_GET_LIST_LOAD",
    API_GET_LIST_SUCCESS: "API_GET_LIST_SUCCESS",
    API_CREATE_CUSTOMER_LOAD: "API_CREATE_CUSTOMER_LOAD",
    API_CREATE_CUSTOMER_SUCCESS: "API_CREATE_CUSTOMER_SUCCESS",
    API_MERGE_CUSTOMER_LOAD: "API_MERGE_CUSTOMER_LOAD",
    API_MERGE_CUSTOMER_SUCCESS: "API_MERGE_CUSTOMER_SUCCESS",
    API_CREATE_CYCLE_COUNT_LOAD: "API_CREATE_CYCLE_COUNT_LOAD",//
    API_CREATE_CYCLE_COUNT_SUCCESS: "API_CREATE_CYCLE_COUNT_SUCCESS",//
    API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_LOAD: "API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_LOAD",
    API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_SUCCESS: "API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_SUCCESS",
    API_ADD_PRODUCT_LOAD: "API_ADD_PRODUCT_LOAD",
    API_ADD_PRODUCT_SUCCESS: "API_ADD_PRODUCT_SUCCESS",
    API_CATEGORY_AND_SUBCATEGORY_LIST_LOAD: "API_CATEGORY_AND_SUBCATEGORY_LIST_LOAD",
    API_CATEGORY_AND_SUBCATEGORY_LIST_SUCCESS: "API_CATEGORY_AND_SUBCATEGORY_LIST_SUCCESS",
    API_UPDATE_PRODUCT_STATUS_LOAD: "API_UPDATE_PRODUCT_STATUS_LOAD",
    API_UPDATE_PRODUCT_STATUS_SUCCESS: "API_UPDATE_PRODUCT_STATUS_SUCCESS",
    API_UPDATE_STICKERING_LOAD: "API_UPDATE_STICKERING_LOAD",
    API_UPDATE_STICKERING_SUCCESS: "API_UPDATE_STICKERING_SUCCESS",
    API_GET_PRODUCT_LIST_LOAD: "API_GET_PRODUCT_LIST_LOAD",
    API_GET_PRODUCT_LIST_SUCCESS: "API_GET_PRODUCT_LIST_SUCCESS",
    API_GET_CUSTOMER_LIST_LOAD: "API_GET_CUSTOMER_LIST_LOAD",
    API_GET_CUSTOMER_LIST_SUCCESS: "API_GET_CUSTOMER_LIST_SUCCESS",
    API_GET_REFERENCE_DATA_LOAD: "API_GET_REFERENCE_DATA_LOAD",
    API_GET_REFERENCE_DATA_SUCCESS: "API_GET_REFERENCE_DATA_SUCCESS",
    API_GET_UPCOMING_CUSTOMER_EVENTS_LOAD: "API_GET_UPCOMING_CUSTOMER_EVENTS_LOAD",
    API_GET_UPCOMING_CUSTOMER_EVENTS_SUCCESS: "API_GET_UPCOMING_CUSTOMER_EVENTS_SUCCESS",
    API_GET_PRODUCT_ITEM_LOAD: "API_GET_PRODUCT_ITEM_LOAD",
    API_GET_PRODUCT_ITEM_SUCCESS: "API_GET_PRODUCT_ITEM_SUCCESS",
    API_CREATE_BILL_LOAD: "API_CREATE_BILL_LOAD",
    API_CREATE_BILL_SUCCESS: "API_CREATE_BILL_SUCCESS",
    API_CREATE_BILL_V2_LOAD: "API_CREATE_BILL_V2_LOAD",
    API_CREATE_BILL_V2_SUCCESS: "API_CREATE_BILL_V2_SUCCESS",
    API_GET_BILLING_LIST_LOAD: "API_GET_BILLING_LIST_LOAD",
    API_GET_BILLING_LIST_SUCCESS: "API_GET_BILLING_LIST_SUCCESS",
    API_GET_BILL_NAVIGATION_ROW_LOAD: "API_GET_BILL_NAVIGATION_ROW_LOAD",
    API_GET_BILL_NAVIGATION_ROW_SUCCESS: "API_GET_BILL_NAVIGATION_ROW_SUCCESS",
    CLEAR_PRODUCT_ITEM_LIST: "CLEAR_PRODUCT_ITEM_LIST",
    REMOVED_PRODUCT_ITEM_LIST: "REMOVED_PRODUCT_ITEM_LIST",
    UPDATE_PRODUCT_ITEM_LIST: "UPDATE_PRODUCT_ITEM_LIST",
    API_APPAREL_LOGIN_LOAD: "API_APPAREL_LOGIN_LOAD",
    API_APPAREL_LOGIN_SUCCESS: "API_APPAREL_LOGIN_SUCCESS",
    API_SEND_LOGIN_OTP_LOAD: "API_SEND_LOGIN_OTP_LOAD",
    API_SEND_LOGIN_OTP_SUCCESS: "API_SEND_LOGIN_OTP_SUCCESS",
    API_VERIFY_LOGIN_OTP_LOAD: "API_VERIFY_LOGIN_OTP_LOAD",
    API_VERIFY_LOGIN_OTP_SUCCESS: "API_VERIFY_LOGIN_OTP_SUCCESS",
    CLEAR_LOGIN_OTP_STATE: "CLEAR_LOGIN_OTP_STATE",
    API_GET_CUSTOMER_HISTORY_LOAD: "API_GET_CUSTOMER_HISTORY_LOAD",
    API_GET_CUSTOMER_HISTORY_SUCCESS: "API_GET_CUSTOMER_HISTORY_SUCCESS",
    API_GET_EMPLOYEE_SALES_HISTORY_LOAD: "API_GET_EMPLOYEE_SALES_HISTORY_LOAD",
    API_GET_EMPLOYEE_SALES_HISTORY_SUCCESS: "API_GET_EMPLOYEE_SALES_HISTORY_SUCCESS",
    API_GET_PRODUCT_HISTORY_LOAD: "API_GET_PRODUCT_HISTORY_LOAD",
    API_GET_PRODUCT_HISTORY_SUCCESS: "API_GET_PRODUCT_HISTORY_SUCCESS",
    API_GET_INVOICE_DETAILS_LOAD: "API_GET_INVOICE_DETAILS_LOAD",
    API_GET_INVOICE_DETAILS_SUCCESS: "API_GET_INVOICE_DETAILSSUCCESS",
    GET_BARCODE_ZIP_FILE: "GET_BARCODE_ZIP_FILE",
    API_UPDATE_MULTIPLE_INVENTORY_LOAD: "API_UPDATE_MULTIPLE_INVENTORY_LOAD",
    API_UPDATE_MULTIPLE_INVENTORY_SUCCESS: "API_UPDATE_MULTIPLE_INVENTORY_SUCCESS",
    API_GET_MULTIPLE_INVENTORY_COUNT_LOAD: "Api_GET_MULTIPLE_INVENTORY_COUNT_LOAD",
    Api_GET_MULTIPLE_INVENTORY_COUNT_SUCCESS: "Api_GET_MULTIPLE_INVENTORY_COUNT_SUCCESS",
    API_GET_MULTIPLE_INVENTORY_SOLD_LIST_LOAD: "API_GET_MULTIPLE_INVENTORY_SOLD_LIST_LOAD",
    API_GET_MULTIPLE_INVENTORY_SOLD_LIST_SUCCESS: "API_GET_MULTIPLE_INVENTORY_SOLD_LIST_SUCCESS",
    API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_LOAD: "API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_LOAD",
    API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_SUCCESS: "API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_SUCCESS",
    API_GET_CATEGORY_SUBCATEGORY_LIST_LOAD: "API_GET_CATEGORY_SUBCATEGORY_LIST_LOAD",
    API_GET_CATEGORY_SUBCATEGORY_LIST_SUCCESS: "API_GET_CATEGORY_SUBCATEGORY_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_CYCLE_COUNT_LOAD: "API_CREATE_OR_UPDATE_CYCLE_COUNT_LOAD",
    API_CREATE_OR_UPDATE_CYCLE_COUNT_SUCCESS: "API_CREATE_OR_UPDATE_CYCLE_COUNT_SUCESS",
    API_GET_CYCLE_COUNT_LIST_LOAD: "API_GET_CYCLE_COUNT_LIST_LOAD",
    API_GET_CYCLE_COUNT_LIST_SUCCESS: "API_GET_CYCLE_COUNT_LIST_SUCCESS",
    API_CYCLE_COUNT_LIST_SEARCH_LOAD: "API_CYCLE_COUNT_LIST_SEARCH_LOAD",
    API_CYCLE_COUNT_LIST_SEARCH_SUCCESS: "API_CYCLE_COUNT_LIST_SEARCH_SUCCESS",
    API_GET_PRODUCT_LIST_CATEGORY_LIST_LOAD: "API_GET_PRODUCT_LIST_CATEGORY_LIST_LOAD",
    API_GET_PRODUCT_LIST_CATEGORY_LIST_SUCCESS: "API_GET_PRODUCT_LIST_CATEGORY_LIST_SUCCESS",
    API_GET_UPDATE_CYCLE_COUNT_LOAD: "API_GET_UPDATE_CYCLE_COUNT_LOAD",
    API_GET_UPDATE_CYCLE_COUNT_SUCCESS: "API_GET_UPDATE_CYCLE_COUNT_SUCCESS",
    API_UPDATE_CYCLE_COUNT_LIST_LOAD: "API_UPDATE_CYCLE_COUNT_LIST_LOAD",
    API_UPDATE_CYCLE_COUNT_LIST_SUCCESS: "API_UPDATE_CYCLE_COUNT_LIST_SUCCESS",
    API_GET_MULTIPLE_SCRAP_LIST_LOAD: "API_GET_MULTIPLE_SCRAP_LIST_LOAD",
    API_GET_MULTIPLE_SCRAP_LIST_SUCCESS: "API_GET_MULTIPLE_SCRAP_LIST_SUCCESS",
    API_GET_CYCLE_COUNT_REPORT_LOAD: "API_GET_CYCLE_COUNT_REPORT_LOAD",
    API_GET_CYCLE_COUNT_REPORT_SUCCESS: "API_GET_CYCLE_COUNT_REPORT_SUCCESS",
    API_GET_REPORT_LIST_LOAD: "API_GET_REPORT_LIST_LOAD",
    API_GET_REPORT_LIST_SUCCESS: "API_GET_REPORT_LIST_SUCCESS",
    API_GET_VENDOR_LIST_LOAD: "API_GET_VENDOR_LIST_LOAD",
    API_GET_VENDOR_LIST_SUCCESS: "API_GET_VENDOR_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_VENDOR_LOAD: "API_CREATE_OR_UPDATE_VENDOR_LOAD",
    API_CREATE_OR_UPDATE_VENDOR_SUCCESS: "API_CREATE_OR_UPDATE_VENDOR_SUCCESS",
    API_GET_VENDOR_EMAIL_VALIDATION_LOAD: "API_GET_VENDOR_EMAIL_VALIDATION_LOAD",
    API_GET_VENDOR_EMAIL_VALIDATION_SUCCESS: "API_GET_VENDOR_EMAIL_VALIDATION_SUCCESS",
    CLEAR_SELECT_LOAD: "CLEAR_SELECT_LOAD",
    VENDOR_DROP_DOWN_LIST_LOAD: "VENDOR_DROP_DOWN_LIST_LOAD",
    VENDOR_DROP_DOWN_LIST_SUCCESS: "VENDOR_DROP_DOWN_LIST_SUCCESS",
    API_GET_VENDOR_PURCHASE_LIST_LOAD: "API_GET_VENDOR_PURCHASE_LIST_LOAD",
    API_GET_VENDOR_PURCHASE_LIST_SUCCESS: "API_GET_VENDOR_PURCHASE_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_VENDOR_PURCHASE_LOAD: "API_CREATE_OR_UPDATE_VENDOR_PURCHASE_LOAD",
    API_CREATE_OR_UPDATE_VENDOR_PURCHASE_SUCCESS: "API_CREATE_OR_UPDATE_VENDOR_PURCHASE_SUCCESS",
    API_GET_RENTAL_LIST_LOAD: "API_GET_RENTAL_LIST_LOAD",
    API_GET_RENTAL_LIST_SUCCESS: "API_GET_RENTAL_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_RENTAL_LOAD: "API_CREATE_OR_UPDATE_RENTAL_LOAD",
    API_CREATE_OR_UPDATE_RENTAL_SUCCESS: "API_CREATE_OR_UPDATE_RENTAL_SUCCESS",
    API_GET_VENDOR_PURCHASE_HISTORY_LOAD: "API_GET_VENDOR_PURCHASE_HISTORY_LOAD",
    API_GET_VENDOR_PURCHASE_HISTORY_SUCCESS: "API_GET_VENDOR_PURCHASE_HISTORY_SUCCESS",
    API_GET_VENDOR_DEBT_LEDGER_LOAD: "API_GET_VENDOR_DEBT_LEDGER_LOAD",
    API_GET_VENDOR_DEBT_LEDGER_SUCCESS: "API_GET_VENDOR_DEBT_LEDGER_SUCCESS",
    API_CREATE_VENDOR_DEBT_ENTRY_LOAD: "API_CREATE_VENDOR_DEBT_ENTRY_LOAD",
    API_CREATE_VENDOR_DEBT_ENTRY_SUCCESS: "API_CREATE_VENDOR_DEBT_ENTRY_SUCCESS",
    MRP_LIST_LOAD: "MRP_LIST_LOAD",
    MRP_LIST_SUCCESS: "MRP_LIST_SUCCESS",
    API_GET_EMPLOYEE_LIST_LOAD: "API_GET_EMPLOYEE_LIST_LOAD",
    API_GET_EMPLOYEE_LIST_SUCCESS: "API_GET_EMPLOYEE_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_EMPLOYEE_LOAD: "API_CREATE_OR_UPDATE_EMPLOYEE_LOAD",
    API_CREATE_OR_UPDATE_EMPLOYEE_SUCCESS: "API_CREATE_OR_UPDATE_EMPLOYEE_SUCCESS",
    EMPLOYEE_DROP_DOWN_LIST_LOAD: "EMPLOYEE_DROP_DOWN_LIST_LOAD",
    EMPLOYEE_DROP_DOWN_LIST_SUCCESS: "EMPLOYEE_DROP_DOWN_LIST_SUCCESS",
    API_GET_ATTENDANCE_LIST_LOAD: "API_GET_ATTENDANCE_LIST_LOAD",
    API_GET_ATTENDANCE_LIST_SUCCESS: "API_GET_ATTENDANCE_LIST_SUCCESS",
    API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_LOAD: "API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_LOAD",
    API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_SUCCESS: "API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_SUCCESS",
    API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_LOAD: "API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_LOAD",
    API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS: "API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS",
    API_GET_ATTENDANCE_RECORD_BY_ID_LOAD: "API_GET_ATTENDANCE_RECORD_BY_ID_LOAD",
    API_GET_ATTENDANCE_RECORD_BY_ID_SUCCESS: "API_GET_ATTENDANCE_RECORD_BY_ID_SUCCESS",
    API_MARK_ATTENDANCE_LOAD: "API_MARK_ATTENDANCE_LOAD",
    API_MARK_ATTENDANCE_SUCCESS: "API_MARK_ATTENDANCE_SUCCESS",
    API_CREATE_OR_UPDATE_PROCUREMENT_LOAD: "API_CREATE_OR_UPDATE_PROCUREMENT_LOAD",
    API_CREATE_OR_UPDATE_PROCUREMENT_SUCCESS: "API_CREATE_OR_UPDATE_PROCUREMENT_SUCCESS",
    API_GET_PROCUREMENT_LIST_LOAD: "API_GET_PROCUREMENT_LIST_LOAD",
    API_GET_PROCUREMENT_LIST_SUCCESS: "API_GET_PROCUREMENT_LIST_SUCCESS",
    API_GET_PROCUREMENT_EXPORT_LIST_LOAD: "API_GET_PROCUREMENT_EXPORT_LIST_LOAD",
    API_GET_PROCUREMENT_EXPORT_LIST_SUCCESS: "API_GET_PROCUREMENT_EXPORT_LIST_SUCCESS",
    API_GET_AUDIT_LOG_LIST_LOAD: "API_GET_AUDIT_LOG_LIST_LOAD",
    API_GET_AUDIT_LOG_LIST_SUCCESS: "API_GET_AUDIT_LOG_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_ATTACHMENT_LOAD: "API_CREATE_OR_UPDATE_ATTACHMENT_LOAD",
    API_CREATE_OR_UPDATE_ATTACHMENT_SUCCESSS: "API_CREATE_OR_UPDATE_ATTACHMENT_SUCCESSS",
    API_GET_ATTACHMENT_LOAD: "API_GET_ATTACHMENT_LOAD",
    API_GET_ATTACHMENT_SUCCESS: "API_GET_ATTACHMENT_SUCCESS",
    API_GET_VENDOR_BILL_ATTACHMENT_LOAD: "API_GET_VENDOR_BILL_ATTACHMENT_LOAD",
    API_GET_VENDOR_BILL_ATTACHMENT_SUCCESS: "API_GET_VENDOR_BILL_ATTACHMENT_SUCCESS",
    API_GET_VENDOR_DEBT_ATTACHMENT_LOAD: "API_GET_VENDOR_DEBT_ATTACHMENT_LOAD",
    API_GET_VENDOR_DEBT_ATTACHMENT_SUCCESS: "API_GET_VENDOR_DEBT_ATTACHMENT_SUCCESS",
    API_GET_SALES_RETURN_LIST_LOAD: "API_GET_SALES_RETURN_LIST_LOAD",
    API_GET_SALES_RETURN_LIST_SUCCESS: "API_GET_SALES_RETURN_LIST_SUCCESS",
    API_CREATE_OR_UPDATE_SALES_RETURN_LOAD: "API_CREATE_OR_UPDATE_SALES_RETURN_LOAD",
    API_CREATE_OR_UPDATE_SALES_RETURN_SUCCESS: "API_CREATE_OR_UPDATE_SALES_RETURN_SUCCESS",
    API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_LOAD: "API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_LOAD",
    API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS: "API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS",
    API_CLEAR_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS: "API_CLEAR_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS",
    API_GET_SALES_RETURN_BILL_DETAILS_LOAD: "API_GET_SALES_RETURN_BILL_DETAILS_LOAD",
    API_GET_SALES_RETURN_BILL_DETAILS_SUCCESS: "API_GET_SALES_RETURN_BILL_DETAILS_SUCCESS",
    API_ADD_CATEGORY_ON_LOAD: "API_ADD_CATEGORY_ON_LOAD",
    API_ADD_CATEGORY_ON_SUCCESS: "API_ADD_CATEGORY_ON_SUCCESS",
    API_CREATE_UPDATE_BANNER_LOAD: 'API_CREATE_UPDATE_BANNER_LOAD',
    API_CREATE_UPDATE_BANNER_SUCCESS: "API_CREATE_UPDATE_BANNER_SUCCESS",
    API_GET_BANNER_LOAD: "API_GET_BANNER_LOAD",
    API_GET_BANNER_SUCCESS: "API_GET_BANNER_SUCCESS",
    API_GET_BANNER_ATTACHMENT_LOAD: "API_GET_BANNER_ATTACHMENT_LOAD",
    API_GET_BANNER_ATTACHMENT_SUCCESS: "API_GET_BANNER_ATTACHMENT_SUCCESS",
    API_ADD_SUB_CATEGORY_ON_LOAD: 'API_ADD_SUB_CATEGORY_ON_LOAD',
    API_ADD_SUB_CATEGORY_ON_SUCCESS: "API_ADD_SUB_CATEGORY_ON_SUCCESS",
    API_GET_HOT_NEW_TOP_PICK_LOAD: "API_GET_HOT_NEW_TOP_PICK_LOAD",
    API_GET_HOT_NEW_TOP_PICK_SUCCESS: "API_GET_HOT_NEW_TOP_PICK_SUCCESS",
    API_UPDATE_HOT_NEW_TOP_PICK_LOAD: "API_UPDATE_HOT_NEW_TOP_PICK_LOAD",
    API_UPDATE_HOT_NEW_TOP_PICK_SUCCESS: "API_UPDATE_HOT_NEW_TOP_PICK_SUCCESS",
    API_GET_ONLINE_ORDER_LOAD: "API_GET_ONLINE_ORDER_LOAD",
    API_GET_ONLINE_ORDER_SUCCESS: "API_GET_ONLINE_ORDER_SUCCESS",
    API_UPDATE_ONLINE_ORDER_LOAD: "API_UPDATE_ONLINE_ORDER_LOAD",
    API_UPDATE_ONLINE_ORDER_SUCCESS: "API_UPDATE_ONLINE_ORDER_SUCCESS",
    API_GET_CORE_CATEGORY_META_LOAD: "API_GET_CORE_CATEGORY_META_LOAD",
    API_GET_CORE_CATEGORY_META_SUCCESS: "API_GET_CORE_CATEGORY_META_SUCCESS",
    UPDATE_PRODUCT_ITEM_QUANTITY: "UPDATE_PRODUCT_ITEM_QUANTITY",
    API_GET_DASHBOARD_DATA_LOAD: "API_GET_DASHBOARD_DATA_LOAD",
    API_GET_DASHBOARD_DATA_SUCCESS: "API_GET_DASHBOARD_DATA_SUCCESS",
    API_GET_TOP_PRODUCTS_LOAD: "API_GET_TOP_PRODUCTS_LOAD",
    API_GET_TOP_PRODUCTS_SUCCESS: "API_GET_TOP_PRODUCTS_SUCCESS",
    API_GET_TOP_CUSTOMERS_LOAD: "API_GET_TOP_CUSTOMERS_LOAD",
    API_GET_TOP_CUSTOMERS_SUCCESS: "API_GET_TOP_CUSTOMERS_SUCCESS",
    API_GET_TOP_CUSTOMERS_EXPORT_PDF_LOAD: "API_GET_TOP_CUSTOMERS_EXPORT_PDF_LOAD",
    API_GET_TOP_CUSTOMERS_EXPORT_PDF_SUCCESS: "API_GET_TOP_CUSTOMERS_EXPORT_PDF_SUCCESS",
    API_GET_SALES_DASHBOARD_DATA_LOAD: "API_GET_SALES_DASHBOARD_DATA_LOAD",
    API_GET_SALES_DASHBOARD_DATA_SUCCESS: "API_GET_SALES_DASHBOARD_DATA_SUCCESS",
    API_GET_INVENTORY_DASHBOARD_DATA_LOAD: "API_GET_INVENTORY_DASHBOARD_DATA_LOAD",
    API_GET_INVENTORY_DASHBOARD_DATA_SUCCESS: "API_GET_INVENTORY_DASHBOARD_DATA_SUCCESS",
    API_GET_CUSTOMER_DASHBOARD_DATA_LOAD: "API_GET_CUSTOMER_DASHBOARD_DATA_LOAD",
    API_GET_CUSTOMER_DASHBOARD_DATA_SUCCESS: "API_GET_CUSTOMER_DASHBOARD_DATA_SUCCESS",
    API_GET_VENDOR_DASHBOARD_DATA_LOAD: "API_GET_VENDOR_DASHBOARD_DATA_LOAD",
    API_GET_VENDOR_DASHBOARD_DATA_SUCCESS: "API_GET_VENDOR_DASHBOARD_DATA_SUCCESS",
    API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_LOAD: "API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_LOAD",
    API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_SUCCESS: "API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_SUCCESS",
    API_GET_VENDOR_DEBT_DASHBOARD_DATA_LOAD: "API_GET_VENDOR_DEBT_DASHBOARD_DATA_LOAD",
    API_GET_VENDOR_DEBT_DASHBOARD_DATA_SUCCESS: "API_GET_VENDOR_DEBT_DASHBOARD_DATA_SUCCESS",
    API_GET_CUSTOM_DASHBOARD_DATA_LOAD: "API_GET_CUSTOM_DASHBOARD_DATA_LOAD",
    API_GET_CUSTOM_DASHBOARD_DATA_SUCCESS: "API_GET_CUSTOM_DASHBOARD_DATA_SUCCESS",
    API_GET_EMPLOYEE_DASHBOARD_DATA_LOAD: "API_GET_EMPLOYEE_DASHBOARD_DATA_LOAD",
    API_GET_EMPLOYEE_DASHBOARD_DATA_SUCCESS: "API_GET_EMPLOYEE_DASHBOARD_DATA_SUCCESS",
    API_GET_STOCK_HISTORY_LOAD: "API_GET_STOCK_HISTORY_LOAD",
    API_GET_STOCK_HISTORY_SUCCESS: "API_GET_STOCK_HISTORY_SUCCESS",
    API_GET_STOCK_MOVEMENT_HISTORY_LOAD: "API_GET_STOCK_MOVEMENT_HISTORY_LOAD",
    API_GET_STOCK_MOVEMENT_HISTORY_SUCCESS: "API_GET_STOCK_MOVEMENT_HISTORY_SUCCESS",
    API_ADMIN_ADJUST_STOCK_LOAD: "API_ADMIN_ADJUST_STOCK_LOAD",
    API_ADMIN_ADJUST_STOCK_SUCCESS: "API_ADMIN_ADJUST_STOCK_SUCCESS",
    // Combo stock — Add Stock's component picker (server-side search) and
    // Edit Stock's read-only component list.
    API_GET_COMBO_COMPONENT_OPTIONS_LOAD: "API_GET_COMBO_COMPONENT_OPTIONS_LOAD",
    API_GET_COMBO_COMPONENT_OPTIONS_SUCCESS: "API_GET_COMBO_COMPONENT_OPTIONS_SUCCESS",
    API_GET_COMBO_ITEMS_LOAD: "API_GET_COMBO_ITEMS_LOAD",
    API_GET_COMBO_ITEMS_SUCCESS: "API_GET_COMBO_ITEMS_SUCCESS",
    API_SET_CUSTOMER_CREDIT_LIMIT_LOAD: "API_SET_CUSTOMER_CREDIT_LIMIT_LOAD",
    API_SET_CUSTOMER_CREDIT_LIMIT_SUCCESS: "API_SET_CUSTOMER_CREDIT_LIMIT_SUCCESS",
    API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_LOAD: "API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_LOAD",
    API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_SUCCESS: "API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_SUCCESS",
    API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_LOAD: "API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_LOAD",
    API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_SUCCESS: "API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_SUCCESS",
    API_GET_CUSTOMER_CREDIT_LEDGER_LOAD: "API_GET_CUSTOMER_CREDIT_LEDGER_LOAD",
    API_GET_CUSTOMER_CREDIT_LEDGER_SUCCESS: "API_GET_CUSTOMER_CREDIT_LEDGER_SUCCESS",
    // Feedback module — dashboard (Reports > Dashboards) + Browse Feedback list.
    // Proxied through apparel-api's FeedbackService to the standalone
    // MF-Customer-Feedback-App-Api service.
    API_GET_FEEDBACK_DASHBOARD_DATA_LOAD: "API_GET_FEEDBACK_DASHBOARD_DATA_LOAD",
    API_GET_FEEDBACK_DASHBOARD_DATA_SUCCESS: "API_GET_FEEDBACK_DASHBOARD_DATA_SUCCESS",
    API_GET_FEEDBACK_LIST_LOAD: "API_GET_FEEDBACK_LIST_LOAD",
    API_GET_FEEDBACK_LIST_SUCCESS: "API_GET_FEEDBACK_LIST_SUCCESS",
    API_GET_FEEDBACK_LOCATIONS_LOAD: "API_GET_FEEDBACK_LOCATIONS_LOAD",
    API_GET_FEEDBACK_LOCATIONS_SUCCESS: "API_GET_FEEDBACK_LOCATIONS_SUCCESS"
}

export default ApiConstants